import Joi from 'joi';
import { LookupListItem } from '../../../api/user/model';

export interface createEdtUserGroupData {
  userGroupName: string;
  approver: LookupListItem;
  remarks: string;
}

export const createEditUserGroupSchema = () =>
  Joi.object({
    userGroupName: Joi.string().required().trim().min(1).messages({
      'string.empty': 'User Group Name must not be empty.',
    }),
    approver: Joi.any().required().messages({
      'any.required': 'Please select Approver.',
    }),
    remarks: Joi.string().required().trim().min(1).messages({}),
  });
